export default function() {
    return {
        username: '',
        error: '',
        message: '',
        firstAccess: false
    }
}
